import React from 'react' 
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
 
import { ServiciosEjecutadosAdminPage } from './admin/ServiciosEjecutadosAdminPage';
import { PlanificacionSejecutadosPage } from './tabs/PlanificacionSejecutados/PlanificacionSejecutadosPage';

const ServiciosEjecutadosRoutes = () => {
    const { path } = useRouteMatch();
    const history = useHistory()

    return (
        <Switch>
            <Route path={`${path}/servicios-ejecutados-admin`} render={(props) => (<ServiciosEjecutadosAdminPage {...props} history={history} />)} />
            <Route path={`${path}/servicios-ejecutados/:id`} render={(props) => (<PlanificacionSejecutadosPage  {...props} history={history} />)} />
        </Switch>  
    )
}
export default ServiciosEjecutadosRoutes; 
